"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./Footer.module.css"));
function Footer(props) {
    var title = props.title, subtitle = props.subtitle, campus = props.campus, year = props.year;
    return (react_1.default.createElement("div", { className: styles.footerWrap },
        react_1.default.createElement("div", { className: styles.footerLeft },
            react_1.default.createElement("strong", null,
                react_1.default.createElement("p", null, title)),
            react_1.default.createElement("p", null, campus + " " + (year === "5.6.2022" ? "Revision Date: July 1, 2022" : subtitle)))));
}
exports.default = Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvYmVsbHVzL0Vucm9sbG1lbnRBZ3JlZW1lbnQvcGFydHMvU2VjdGlvbjEvRm9vdGVyL0Zvb3Rlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQXlCO0FBQ3pCLDBEQUE2QztBQUU3QyxTQUF3QixNQUFNLENBQUMsS0FBSztJQUN6QixJQUFBLG1CQUFLLEVBQUUseUJBQVEsRUFBRSxxQkFBTSxFQUFFLGlCQUFJLENBQVM7SUFDN0MsT0FBTyxDQUNILHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsVUFBVTtRQUM3Qix1Q0FBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLFVBQVU7WUFDN0I7Z0JBQ0kseUNBQUksS0FBSyxDQUFLLENBQ1Q7WUFDVCx5Q0FBTyxNQUFNLFVBQ1QsSUFBSSxLQUFLLFVBQVUsQ0FBQyxDQUFDLENBQUMsNkJBQTZCLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FDaEUsQ0FBSyxDQUNMLENBQ0osQ0FDVCxDQUFBO0FBQ0wsQ0FBQztBQWRELHlCQWNDIn0=